import { render, staticRenderFns } from "./matchingMail.vue?vue&type=template&id=7292d3bc&"
import script from "./matchingMail.vue?vue&type=script&lang=js&"
export * from "./matchingMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports